const ERROR: { [key: number]: string } = {
    7: `Lamentablemente tuvimos un inconveniente con tu pedido
        Generamos el pedido {{idPedidoReemplazante}} el cual será surtido y enviado en breve
        Te pedimos disculpas por el inconveniente`
}

export default ERROR
